window.rcLoginAccessLink = {
    settings: [
        {
            page: '/',
            injectionAnchorSelectors: ["#customer_login .fields .description-block"],
            injectionPosition: 'afterend'
        }
    ]
};
$(function () {
    var productId = $('body').data('id');
    
    var rechargeWidgetInterval = setInterval(function() {
        function updateAddToCartButton() {
            var isSuscription = Recharge?.widgets?.[productId]?.state?.sellingPlan;
            $('.product-form__submit > span').text(isSuscription ? 'Subscribe' : 'Add to cart');
        }
        function updatePrice() {
            var widget = Recharge?.widgets?.[productId];
            var variantId = widget?.state?.variant;
            var isSuscription = widget?.state?.sellingPlan;
            var prices = Recharge?.widgets?.[productId]?.config?.formattedVariantPrices?.[variantId];
            if (prices) {
                $('.price-item.price-item--sale').html(isSuscription ? prices.discounted : prices.unit);
            }

        }
        function initRechrgePlugin() {
            var recharge = window.Recharge;
            var widget = productId && recharge.widgets[productId];
            var variantId = widget?.state?.variant;
            var isSuscription = widget?.state?.sellingPlan;
            var prices = Recharge?.widgets?.[productId]?.config?.formattedVariantPrices?.[variantId];
            if (widget) {
                if (widget.state.sellingPlan) {
                    $('.product-form__submit > span').text('Subscribe');
                    if (prices) {
                        $('.price-item.price-item--sale').html(isSuscription ? prices.discounted : prices.unit);
                    }
                }
                Recharge.eventService.addEventListener(`${productId}:sellingPlan:change`, function() {
                    updateAddToCartButton();
                    updatePrice();
                    console.log('selling plan change for ', productId);
                });
            }
        }

        if (window.Recharge) {
            initRechrgePlugin();
            
            clearInterval(rechargeWidgetInterval);
        }
    }, 200);


    $('.ingredients-block').on('click', function (e) {
        $(this).toggleClass('active');
        var clickPosition = e.originalEvent.clientY;
        var el = $('.nutrition-facts');
        var height = el.height();
        var targetPosition = clickPosition - (height < 200 ? height + 350 : height) + 50;
        $('.nutrition-facts').css({'top': `-${targetPosition}px`})
    });
    $('.ingredients-block .close').on('click', function (e) {
        e.stopPropagation();
        $(this).closest('.ingredients-block').toggleClass('active');
    });

    const initialText = $('.rc-radio.onetime-radio .rc-radio__label').text();
    function getSeparatedText(text) {
        const res = /([a-zA-Z\s\-]*)\s(\$\d{1,10}\.\d{1,2})/.exec(text);
        if (res && res[1] && res[2]) {
            return {
                text: res[1],
                price: res[2]
            }
        }
        return false;
    }
    function getSeparatedHtml(separatedText) {
        return `<span class="rc-radio__subscription">${separatedText.text}</span><span class="rc-radio__price"> ${separatedText.price}</span>`;
    }
    function updateOneTimeBlock() {
        const initialText = $('.rc-radio.onetime-radio .rc-radio__label').text();
        const separatedText = getSeparatedText(initialText);
        if (!separatedText) {
            return false;
        }
        const html = `<span class="rc-radio__subscription">${separatedText.text}</span><span class="rc-radio__price"> ${separatedText.price}</span>`;
        $('.rc-radio.onetime-radio .rc-radio__label').html(html);
        return true;
    }

    function updateAddToCartButton() {
        //  Recharge.eventService.addEventListener('6833628577879:sellingPlan:change', function(a) { console.log(a)})
        // 6833628577879 - earlgrey
        // Recharge.widgets['6833628577879'].
        // Recharge.widgets['6833628577879'].state.sellingPlan
        // Recharge.widgets['6833628577879'].state.variant => 40031835488343
        // Recharge.widgets['6833628577879'].config.formattedVariantPrices['40031835488343'].unit
        // Recharge.widgets['6833628577879'].config.formattedVariantPrices['40031835488343'].discounted

        
    }

    if (initialText && getSeparatedText(initialText)) {
        updateOneTimeBlock();
    } else {
        let maxIterationCount = 20;
        const oneTimeBlockUpdateIntervalId = setInterval(function() {
            maxIterationCount--;
            if (maxIterationCount < 0 || updateOneTimeBlock()) {
                clearInterval(oneTimeBlockUpdateIntervalId);
            }
        }, 500)
    }

});